import { STORAGE_EXPIRES_TIME } from '../common/constants';
import { isLocalStorageEnabled } from './environment';
import loggerManager from './log/logger-manager';

/**
 * Storage 模块，基于 LocalStorage 封装
 * @class Storage
 */
class Storage {
  _prefix = 'TRTC';
  _queue = new Map<string, { expiresIn: number, value: any; }>();

  getRealKey(key: string) {
    return `${this._prefix}_${key}`;
  }

  /**
   * 检查数据是否过期，清理过期的数据
   * @memberof Storage
   */
  checkStorage() {
    if (!isLocalStorageEnabled()) {
      return;
    }
    setInterval(this.doFlush.bind(this), 20000);
    const keys = Object.keys(localStorage);
    const keysToRemove = keys.filter(key => {
      if (key.startsWith(this._prefix)) {
        try {
          const stringifyData = localStorage.getItem(key);
          if (!stringifyData) return false;
          const data = JSON.parse(stringifyData);
          if (data && data.expiresIn < Date.now()) {
            return true;
          }
        } catch (error) {
          return false;
        }
      }
      return false;
    });

    keysToRemove.forEach(key => localStorage.removeItem(key));
  }

  doFlush() {
    if (!isLocalStorageEnabled()) {
      return;
    }
    try {
      for (const [key, value] of this._queue) {
        localStorage.setItem(key, JSON.stringify(value));
      }
    } catch (error) {
      loggerManager.warn(error);
    }
  }

  getItem(key: string) {
    if (!isLocalStorageEnabled()) {
      return null;
    }
    try {
      const stringifyData = localStorage.getItem(this.getRealKey(key));
      if (!stringifyData) return null;
      const data = JSON.parse(stringifyData);
      // 若数据过期则不返回数据
      if (data && data.expiresIn >= Date.now()) {
        return data.value;
      }
      return null;
    } catch (error) {
      loggerManager.warn(error);
    }
  }

  setItem(key: string, value: any) {
    if (!isLocalStorageEnabled()) {
      return;
    }
    try {
      const data = {
        expiresIn: Date.now() + STORAGE_EXPIRES_TIME,
        value
      };
      this._queue.set(this.getRealKey(key), data);
    } catch (error) {
      loggerManager.warn(error);
    }
  }

  deleteItem(key: string) {
    if (!isLocalStorageEnabled()) {
      return false;
    }
    try {
      key = this.getRealKey(key);
      this._queue.delete(key);
      localStorage.removeItem(key);
      return true;
    } catch (error) {
      loggerManager.warn(error);
      return false;
    }
  }

  clear() {
    if (!isLocalStorageEnabled()) {
      return;
    }
    try {
      localStorage.clear();
    } catch (error) {
      loggerManager.warn(error);
    }
  }
}

export default new Storage();
